module.exports = __webpack_public_path__ + "dimer/static/img/project5.2fa69e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project5.jpg
// module id = a+js
// module chunks = 0